<template>
    <div class="slide ci" :key="slideData?slideData.url:'slide'" >

      <div class="content fade-on-show" v-html="slideData.html" v-if="slideData && slideData.html" style="transition:0.3s opacity;" :data-active="show"></div>
      <div class="content fade-on-show" v-else-if="slideData && slideData.image" style="transition:0.3s opacity;" :data-active="show">
        <div class="ci-slide bg-black fade-on-load transition-opacity duration-300" >
          <img class="absolute w-full h-full cover" width="100%" height="100%" :src="slideData.image">
        </div>
      </div>
      <div class="content" v-else-if="slideData && slideData.url">
        <iframe :src="slideData.url" class="content"></iframe>
      </div>

      <label v-if="devMsg" class="dev-msg">{{ devMsg }}</label>

    </div>
    
</template>

<script>
    export default {
        name: "slide-loader",

        watch: {
            slideUrl: function(val){
                if(!this.useIframe){
                    this.getSlideContent(val);
                }

            },
          slideData: function(val,oldVal){
              if(val !== oldVal){
                this.show = false;
                console.log("hiding")

                this.$nextTick(()=>{
                  console.log("showing")
                  this.show = true;
                })

              }
            console.log("slideData", val, oldVal)

          }
        },
        props: {
            slideUrl: {
                default: ""
            },

            slideData: {
              default: function(){
                return {
                  html: "",
                  image: "",
                  url: "",
                }
              }
            },

            useTemp: {
                default: ""
            },

            imageURL: {
              default: ""
            },

            html: {
              default: ""
            },

            useIframe: {
                default: false
            },

            baseUrl: {
                default: "/html/"
            },

            baseThumbUrl: {
                default: "/slides/"
            },
        },

        data: function(){
            return {
                htmlContent: "",
                devMsg: "",
                show: false
            }
        },

        computed: {

        },

        methods: {




            getSlideContent: async function(url){
                if(url){
                    ////console.log(url);

                    if(url.indexOf(".html") > 0){
                        let response = await fetch(this.baseUrl + url);
                        let content = await response.text();
                        if(content){

                            var bodyContent = content.replace(/<head>(\n*)(.*?)(\n*)<\/head>/, "");

                            this.htmlContent = bodyContent;
                            this.devMsg = ""
                            return;
                        }
                    }else{

                        let imgURL = `${this.baseThumbUrl}${url}`;
                        ////console.log(imgURL);
                        let imgHTML =  `
                            <div class='ci-thumb'>

                                        <img src="${imgURL}" alt="Content Missing"/>


                            </div>
                        `

                        ////console.log(imgHTML);
                        this.htmlContent = imgHTML;
                        //this.devMsg = "This is a placeholder image."
                        return;
                    }

                    ////console.log(content);
                }else{
                    //console.log("no content url provided...");

                }

                this.devMsg = ""

                this.htmlContent = "";


            }
        }
    }
</script>

<style>

    @font-face {
        font-family: "Material Icons";
        src: url("/fonts/Material-Design-Iconic-Font.ttf") format("truetype");
    }




    iframe.content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;

      background-color: black;



    }


    .dev-msg {
        padding: 1em;
        background-color: rgba(255,255,0, 0.9);
        color: black;

        position: absolute;
        top: 2em;
        right: 2em;
        text-align: right;





    }


    .ci.slide {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        background-color: black;

    }

    .ci-slide {
        font-size: 0.7vw;
    }

    .ci-thumb {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0em;
    }

    .ci-thumb img {
        width: 100%;
        margin: 0;
    }

    /* html css */

    .ci-slide {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 0;
        padding-bottom: calc(100% * (9/16));
        box-sizing: border-box;


        overflow: hidden;

        font-family: "Myriad", Arial, "Helvetica Neue", Helvetica, sans-serif;


    }

    .ci-slide .icon-font {
        font-family: 'Material Icons';
        font-weight: normal;
        font-style: normal;
        font-size: 24px;  /* Preferred icon size */
        display: inline-block;
        line-height: 1;
        text-transform: none;
        letter-spacing: normal;
        word-wrap: normal;
        white-space: nowrap;
        direction: ltr;

        /* Support for all WebKit browsers. */
        -webkit-font-smoothing: antialiased;
        /* Support for Safari and Chrome. */
        text-rendering: optimizeLegibility;

        /* Support for Firefox. */
        -moz-osx-font-smoothing: grayscale;

        /* Support for IE. */
        font-feature-settings: 'liga';
    }

    .ci-slide .font-normal {
        font-weight: normal;
    }

    .ci-slide .font-bold {
        font-weight: bold;
    }



    .ci-slide h1 {
        font-size: 4em;
        margin: 0;
    }

    .ci-slide h2 {
        font-size: 2.5em;
        margin: 0;
    }

    .ci-slide h3 {
        font-size: 2.0em;
        margin: 0;
    }

    .ci-slide h4 {
        font-size: 1.75em;
        margin: 0;
    }

    .ci-slide p {
        font-size: 1.5em;
        margin: 0;
        margin-bottom: 1em;
        line-height: 1.3em;
    }

    .ci-slide ul {
        padding-left: 1.5em;
    }

    .ci-slide ul li {

    }

    .ci-slide ul p {
        margin-bottom: 0.5em;
    }


    .ci-slide div {
        box-sizing: border-box;
    }

    .ci-slide .block {
        display: block;
    }

    .ci-slide .top {
        top: 0;
    }

    .ci-slide .left {
        left: 0;
    }

    .ci-slide .right {
        right: 0;
    }

    .ci-slide .bottom {
        bottom: 0;
    }

    .ci-slide .absolute {
        position: absolute;
    }

    .ci-slide .relative {
        position: relative;
    }

    .ci-slide .w-full {
        width: 100%;
    }

    .ci-slide .h-full {
        height: 100%;
    }

    .ci-slide .bkg-black {
        background-color: black;
        color: white;
    }

    .ci-slide .bkg-white {
        background-color: white;
        color: black;
    }

    .ci-slide .bkg-gray {
        background-color: #555;
        color: white;
    }

    .ci-slide .bkg-red {
        background-color: #cb2026;
        color: white;
    }




    .ci-slide .text-red {
        color: #cb2026;
    }

    .ci-slide .text-gray {
        color: #777777;
    }

    .ci-slide .text-black {
        color: #000000;
    }

    .ci-slide .text-blue {
        color: #1F497D;
    }

    .ci-slide .text-blue-bright {
        color: #007bf0;
    }


    /*.ci-slide .col img {*/
    /*width: 100%;*/
    /*max-height: 100%;*/
    /*}*/

    /*.ci-slide img.auto-size {*/
    /*height: auto;*/
    /*width: 100%;*/
    /*}*/

    .ci-slide .flex {
        display: flex;
    }

    .ci-slide .flex-col {
        display: flex;
        flex-direction: column;
    }

    .ci-slide .items-center {
        align-items: center;
    }

    .ci-slide .justify-between {
        justify-content: space-between;
    }

    .ci-slide .justify-center {
        justify-content: center;
    }

    .ci-slide .grow {
        flex-grow: 1;
    }

    .ci-slide .shrink {
        flex-shrink: 1;
    }

    .ci-slide img.cover {
        object-fit: cover;
    }

    .ci-slide img.contain {
        object-fit: contain;
    }

    .ci-slide .border {
        border: 1px solid white;
    }



    .ci-slide .border-l {
        border-left: 1px solid white;
    }

    .ci-slide .border-r {
        border-right: 1px solid white;
    }

    .ci-slide .border-t {
        border-top: 1px solid white;
    }

    .ci-slide .border-b {
        border-bottom: 1px solid white;
    }

    .ci-slide .border-gray {
        border-color: gray;
    }

    .ci-slide .border-black {
        border-color: black;
    }

    .ci-slide .border-red {
        border-color:  #cb2026;
    }

    .ci-slide .border-blue {
        border-color: rgba(75,169,218, 0.7);
    }

    .ci-slide .shadow-blue {
        box-shadow: rgba(75,169,218, 1.0) 0 0 10px;
    }

    .ci-slide .border-2 {
        border-width: 2px;
    }

    .ci-slide .border-4 {
        border-width: 4px;
    }

    .ci-slide .text-right {
        text-align: right;
    }

    .ci-slide .text-left {
        text-align: left;
    }

    .ci-slide .text-center {
        text-align: center;
    }

    .ci-slide .row {
        position: relative;
    }

    .ci-slide .col {
        position: relative;
        box-sizing: border-box;
        margin-right: 3em;

    }

    .ci-slide .row + .row {
        margin-top: 2em;
    }

    .ci-slide .col:last-child {
        margin-right: 0;
    }


    .ci-slide .w-1-10 {
        width: 10%;
    }

    .ci-slide .w-2-10 {
        width: 20%;
    }

    .ci-slide .w-3-10 {
        width: 30%;
    }

    .ci-slide .w-4-10 {
        width: 40%;
    }

    .ci-slide .w-5-10 {
        width: 50%;
    }

    .ci-slide .w-6-10 {
        width: 60%;
    }

    .ci-slide .w-7-10 {
        width: 70%;
    }

    .ci-slide .w-8-10 {
        width: 80%;
    }

    .ci-slide .w-9-10 {
        width: 90%;
    }

    .ci-slide .w-10-10 {
        width: 100%;
    }

    .ci-slide .h-1-10 {
        height: 10%;
    }

    .ci-slide .h-2-10 {
        height: 20%;
    }

    .ci-slide .h-3-10 {
        height: 30%;
    }

    .ci-slide .h-4-10 {
        height: 40%;
    }

    .ci-slide .h-5-10 {
        height: 50%;
    }

    .ci-slide .h-6-10 {
        height: 60%;
    }

    .ci-slide .h-7-10 {
        height: 70%;
    }

    .ci-slide .h-8-10 {
        height: 80%;
    }

    .ci-slide .h-9-10 {
        height: 90%;
    }

    .ci-slide .h-10-10 {
        height: 100%;
    }

    .ci-slide .h-3em {
        height: 3em;
    }

    .ci-slide .h-4em {
        height: 4em;
    }



    .ci-slide .-m-x-2 {
        margin-left: -2em;
        margin-right: -2em;
    }

    .ci-slide .scale-150 {
        transform: scale(1.5);
    }

    .ci-slide .scale-125 {
        transform: scale(1.25);
    }

    .ci-slide .mt-0 {
        margin-top: 0em;
    }

    .ci-slide .mt-0-5 {
        margin-top: 0.5em;
    }

    .ci-slide .mt-1 {
        margin-top: 1em;
    }

    .ci-slide .mt-2 {
        margin-top: 2em;
    }

    .ci-slide .mt-3 {
        margin-top: 3em;
    }

    .ci-slide .mt-4 {
        margin-top: 4em;
    }

    .ci-slide .mb-0 {
        margin-bottom: 0em;
    }

    .ci-slide .mb-0-5 {
        margin-bottom: 0.5em;
    }

    .ci-slide .mb-1 {
        margin-bottom: 1em;
    }

    .ci-slide .mb-2 {
        margin-bottom: 2em;
    }

    .ci-slide .mb-3 {
        margin-bottom: 3em;
    }

    .ci-slide .mb-4 {
        margin-bottom: 4em;
    }

    .ci-slide .mr-1 {
        margin-right: 1em;
    }

    .ci-slide .mr-2 {
        margin-right: 2em;
    }

    .ci-slide .mr-3 {
        margin-right: 3em;
    }

    .ci-slide .mr-4 {
        margin-right: 4em;
    }

    .ci-slide .ml-1 {
        margin-left: 1em;
    }

    .ci-slide .ml-2 {
        margin-left: 2em;
    }

    .ci-slide .ml-3 {
        margin-left: 3em;
    }

    .ci-slide .ml-4 {
        margin-left: 4em;
    }

    .ci-slide .mx-1 {
        margin-left: 1em;
        margin-right: 1em;
    }

    .ci-slide .mx-2 {
        margin-left: 2em;
        margin-right: 2em;
    }

    .ci-slide .mx-3 {
        margin-left: 3em;
        margin-right: 3em;
    }

    .ci-slide .mx-4 {
        margin-left: 4em;
        margin-right: 4em;
    }

    .ci-slide .mx-6 {
        margin-left: 6em;
        margin-right: 6em;
    }

    .ci-slide .my-1 {
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .ci-slide .my-2 {
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .ci-slide .my-3 {
        margin-top: 3em;
        margin-bottom: 3em;
    }

    .ci-slide .my-4 {
        margin-top: 4em;
        margin-bottom: 4em;
    }

    .ci-slide .my-6 {
        margin-top: 6em;
        margin-bottom: 6em;
    }

    /* padding */

    .ci-slide .px-1 {
        padding-left: 1em;
        padding-right: 1em;
    }

    .ci-slide .px-2 {
        padding-left: 2em;
        padding-right: 2em;
    }

    .ci-slide .px-3 {
        padding-left: 3em;
        padding-right: 3em;
    }

    .ci-slide .px-4 {
        padding-left: 4em;
        padding-right: 4em;
    }

    .ci-slide .px-6 {
        padding-left: 6em;
        padding-right: 6em;
    }

    .ci-slide .py-0-5 {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
    }

    .ci-slide .py-1 {
        padding-top: 1em;
        padding-bottom: 1em;
    }

    .ci-slide .py-2 {
        padding-top: 2em;
        padding-bottom: 2em;
    }

    .ci-slide .py-3 {
        padding-top: 3em;
        padding-bottom: 3em;
    }

    .ci-slide .py-4 {
        padding-top: 4em;
        padding-bottom: 4em;
    }

    .ci-slide .py-6 {
        padding-top: 6em;
        padding-bottom: 6em;
    }


    .ci-slide .pt-1 {
        padding-top: 1em;
    }

    .ci-slide .pt-2 {
        padding-top: 2em;
    }

    .ci-slide .pt-3 {
        padding-top: 3em;
    }

    .ci-slide .pt-4 {
        padding-top: 4em;
    }

    .ci-slide .pb-1 {
        padding-bottom: 1em;
    }

    .ci-slide .pb-2 {
        padding-bottom: 2em;
    }

    .ci-slide .pb-3 {
        padding-bottom: 3em;
    }

    .ci-slide .pb-4 {
        padding-bottom: 4em;
    }

    .ci-slide .pr-1 {
        padding-right: 1em;
    }

    .ci-slide .pr-2 {
        padding-right: 2em;
    }

    .ci-slide .pr-3 {
        padding-right: 3em;
    }

    .ci-slide .pr-4 {
        padding-right: 4em;
    }

    .ci-slide .pl-1 {
        padding-left: 1em;
    }

    .ci-slide .pl-2 {
        padding-left: 2em;
    }

    .ci-slide .pl-3 {
        padding-left: 3em;
    }

    .ci-slide .pl-4 {
        padding-left: 4em;
    }

    .ci-slide .collapse {
        border-collapse: collapse;
    }

    .ci-slide .data-table {
        background-color: #44768b;
        color: white;
        border-collapse: collapse;
        font-size: 1.2em;


    }

    .ci-slide table td, .ci-slide table th {
        padding: 0.5em;
    }

    .ci-slide .data-table td:first-child, .ci-slide .data-table th:first-child {
        padding-left: 1em;
    }

    .ci-slide .data-table td:last-child, .ci-slide .data-table th:last-child {
        padding-right: 1em;
    }

    .ci-slide table thead th {
        padding-top: 1em;
        font-weight: bold;
    }

    .ci-slide table tfoot td {
        padding-bottom: 1em;
    }

    .content.fade-on-show {
      opacity: 0;
    }

    .content.fade-on-show[data-active="true"]{
      opacity: 1;
    }



    .video-container {

    }




</style>

<style scoped>

</style>